import { OrderData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';

const baseApi = apiResource<OrderData>('orders');

const apiBaseUrl = getApiBaseUrl();
export const API_URL = apiBaseUrl + '/v2';
import apiFetch from 'common/services/apiFetch';

async function request<T>(
	url: string,
	method: string,
	token: string,
	body?: Partial<T>
): Promise<T> {
	const res = await apiFetch(`${API_URL}${url}`, {
		method,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: body ? JSON.stringify(body) : undefined,
	});
	if (!res.ok) throw new Error(`Failed to ${method} ${url}`);
	return method === 'DELETE' ? (undefined as unknown as T) : res.json();
}

const baseUrl = `/orders`;

export const ordersApi = {
	...baseApi, // CRUD générique

	previewReference: (token: string, year: number) =>
		request<{ nextReference: string }>(
			`${baseUrl}/preview-reference/${year}`,
			'GET',
			token
		),
};
